import React from 'react'
import styled from 'styled-components'
import {
  Select,
  Input,
  Divider,
  Switch,
  InputNumber,
  Tabs,
  Upload,
  message,
  Button,
  Popconfirm,
  Table,
} from 'antd'
import { isErrorContains } from './../../../core/component/JcTmpErrorDialog'
import {
  domonionCard97Attachment,
  getAuthorization,
  getCredentials,
} from 'api/pgads'
import { v4 as uuidv4 } from 'uuid'
import querystring from 'querystring'
import { exportData } from 'core'
import moment from 'moment'

const Label = styled.div`
  display: grid;
  align-content: center;
  justify-content: end;
`

const DominionExtension = props => {
  const {
    data,
    handleExtSave,
    // mode = 'V',
    // lock = 'U',
    // isAdmin = false,
    disableComp = false,
    targetInfo,
    allData,
    setSpinning,
    setError,
    handleChange,
  } = props

  const {
    primaryAlert = 'N', // humPer , Y N
    excludeInGoals = 'N', // exGoal Y N
    automaticTrip = '0', // trip selection  Hp=2 EF=1 else 0
    includeInMmpi = 'N', // inclu mmpi   Y N
    includeInDir = 'N', // Y N
    significantEvent = 'N', // sigEvent Y N
    startType = '0', // cold = 0 hpot=1 warm=2
    cumulatEngHrs = '',
    cumulatFiredHrs = '',
    extendedDes = '', // text area etended des
    causeDes = '', // text area  cause code desc
    correctiveAction = '', // corrective Action
    string4 = '',
    number1 = '',
    // number2 = '',
    string1 = '',
    string2 = 'N',
    string3 = '',
  } = data

  const onChange = (checked, id) => handleExtSave(id, checked ? 'Y' : 'N')

  // const { setTmpError } = useContext(JcTmpErrorContext)

  const { card97fileList = [], eventNum, unit, utility, year } = allData

  const fileProps = {
    name: 'file',

    action: `${
      targetInfo.baseUrl
    }/dominion/dom-card97-attach-file?${querystring.stringify({
      year,
      unit,
      utility,
      eventnum: eventNum,
      uuid: uuidv4(),
    })}`,
    method: 'POST',
    data: props.importData || {},
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const deleteAttachment = uuid => {
    setSpinning(true)
    domonionCard97Attachment(targetInfo)({
      year,
      unit,
      utility,
      eventnum: eventNum,
      uuid,
    }).fork(setError, data => {
      setSpinning(false)
      message.success('File deleted successfully')
      handleChange({ name: 'card97fileList', value: data })
    })
  }

  const downloadAttachemnetFile = targetInfo => (fileName, uuid) => {
    const URL = `${
      targetInfo.baseUrl
    }/dominion/download-card97-attachment-file?${querystring.stringify({
      fileName,
      uuid,
    })}`
    return fetch(`${URL}`, {
      method: 'GET',
      ignoreAuth: true,
      ...getCredentials(targetInfo),
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
        ...getAuthorization(targetInfo),
      },
    })
      .then(response => {
        if (response.ok) return response
        else throw new Error('Something went wrong')
      })
      .then(response => response.blob())
      .then(blob =>
        // exportData(blob, 'application/pdf', decodeURIComponent(fileName))
        exportData(blob, '', decodeURIComponent(fileName))
      )
      .catch(error => message.error('Error in File ' + error))
  }

  return (
    <Tabs type="card">
      <Tabs.TabPane key="ext" tab="Extended">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '150px 100px 150px 100px 150px 100px 150px',
            gridRowGap: '5px',
            gridColumnGap: '10px',
            width: '90%',
          }}
        >
          <Label>Human Performance :</Label>
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Switch
              disabled={disableComp}
              style={{ display: 'grid', alignContent: 'center' }}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => onChange(checked, 'primaryAlert')}
              checked={primaryAlert === 'Y'}
            />
          </div>
          <Label>Include in MMPI :</Label>
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Switch
              disabled={disableComp}
              style={{ display: 'grid', alignContent: 'center' }}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => onChange(checked, 'includeInMmpi')}
              checked={includeInMmpi === 'Y'}
            />
          </div>
          <Label>Start Type :</Label>
          <Select
            disabled={disableComp}
            value={startType}
            onChange={val => handleExtSave('startType', val)}
          >
            <Select.Option key="0">Cold</Select.Option>
            <Select.Option key="1">Hot</Select.Option>
            <Select.Option key="2">Warm</Select.Option>
          </Select>
          <div style={{ gridRowEnd: 'span 5' }} />
          <Label>Exclude in Goals :</Label>
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Switch
              disabled={disableComp}
              style={{ display: 'grid', alignContent: 'center' }}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => onChange(checked, 'excludeInGoals')}
              checked={excludeInGoals === 'Y'}
            />
          </div>
          <Label>Include in Dir Report :</Label>
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Switch
              disabled={disableComp}
              style={{ display: 'grid', alignContent: 'center' }}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => onChange(checked, 'includeInDir')}
              checked={includeInDir === 'Y'}
            />
          </div>
          <Label>Cumulative Fired Hrs :</Label>
          <InputNumber
            disabled={disableComp}
            value={cumulatFiredHrs}
            onChange={value => handleExtSave('cumulatFiredHrs', value)}
          />
          <Label>Automatic Trip :</Label>
          <Select
            disabled={disableComp}
            value={automaticTrip}
            onChange={val => handleExtSave('automaticTrip', val)}
          >
            <Select.Option key="0">N/A</Select.Option>
            <Select.Option key="1">EF</Select.Option>
            <Select.Option key="2">HP</Select.Option>
          </Select>
          <Label>Significant Event :</Label>
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Switch
              disabled={disableComp}
              style={{ display: 'grid', alignContent: 'center' }}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => onChange(checked, 'significantEvent')}
              checked={significantEvent === 'Y'}
            />
          </div>
          <Label>Cumulative Eng Starts :</Label>
          <InputNumber
            disabled={disableComp}
            value={cumulatEngHrs}
            onChange={value => handleExtSave('cumulatEngHrs', value)}
          />
          <Divider style={{ gridColumnEnd: 'span 6', margin: '10px 0' }} />
          <Tabs
            style={{ gridColumnEnd: 'span 7' }}
            type="card"
            // tabBarExtraContent={<div>Max length is 4000 charactor</div>}
          >
            <Tabs.TabPane tab="Extended Description" key="extdes">
              <Input.TextArea
                disabled={disableComp}
                style={{ gridColumnEnd: 'span 6' }}
                value={extendedDes}
                onChange={e => handleExtSave('extendedDes', e.target.value)}
                autoSize={{ minRows: 7, maxRows: 7 }}
                allowClear
                maxLength={4000}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Description of the Cause" key="caudes">
              <Input.TextArea
                style={{ gridColumnEnd: 'span 6' }}
                disabled={disableComp}
                rows={2}
                autoSize={{ minRows: 7, maxRows: 7 }}
                value={causeDes}
                onChange={e => handleExtSave('causeDes', e.target.value)}
                allowClear
                maxLength={4000}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Short Term Corrective Action" key="coract">
              <Input.TextArea
                disabled={disableComp}
                style={{ gridColumnEnd: 'span 6' }}
                rows={2}
                value={correctiveAction}
                onChange={e =>
                  handleExtSave('correctiveAction', e.target.value)
                }
                autoSize={{ minRows: 7, maxRows: 7 }}
                allowClear
                maxLength={4000}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Long Term Corrective Action" key="longterm">
              <Input.TextArea
                disabled={disableComp}
                style={{ gridColumnEnd: 'span 6' }}
                rows={2}
                value={string4}
                onChange={e => handleExtSave('string4', e.target.value)}
                autoSize={{ minRows: 7, maxRows: 7 }}
                allowClear
                maxLength={4000}
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Tabs.TabPane>
      <Tabs.TabPane key="workorder" tab="Work Order">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 150px 200px 150px auto',
            gridRowGap: '5px',
            gridColumnGap: '10px',
            width: '90%',
          }}
        >
          <Label>Originating Event Work Order :</Label>
          <InputNumber
            disabled={disableComp}
            value={number1}
            onChange={value => handleExtSave('number1', value)}
            style={{ width: '100%' }}
          />
          <Label>EDART Ticket Number :</Label>
          <Input
            disabled={disableComp}
            value={string1}
            onChange={e => handleExtSave('string1', e.target.value)}
            style={{ width: '100%' }}
          />
          <div />
          <Label>Secondary Work Orders :</Label>
          <Input
            disabled={disableComp}
            value={string3}
            onChange={e => {
              const value = e.target.value
              let sp = value.split(',')
              sp = sp.filter(f => isNaN(f))
              if (sp.length <= 0) handleExtSave('string3', value)
            }}
            style={{ width: '100%' }}
          />

          <Label> RCA Required :</Label>
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Switch
              disabled={disableComp}
              style={{ display: 'grid', alignContent: 'center' }}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => onChange(checked, 'string2')}
              checked={string2 === 'Y'}
            />
          </div>
          <div />
          <Divider
            style={{ gridColumnEnd: 'span 5', marginTop: 10, marginBottom: 10 }}
          />
          <div style={{ gridColumnEnd: 'span 5' }}>
            <Upload
              disabled={disableComp}
              {...fileProps}
              beforeUpload={_ => setSpinning(true)}
              onChange={data => {
                if (data.file.status === 'done') {
                  setSpinning(false)

                  if (
                    data.file.response &&
                    data.file.response.restfulStatus &&
                    data.file.response.restfulStatus === 'FAILURE'
                  ) {
                    setError(data.file.response)
                  } else {
                    if (!isErrorContains(data.file.response))
                      message.success('File imported successfully')

                    handleChange({
                      name: 'card97fileList',
                      value: data.file.response,
                    })
                  }
                }
                if (data.file.status === 'error') {
                  setSpinning(false)
                  setError(data.file.response)
                }
              }}
              multiple={false}
              showUploadList={false}
            >
              <Button
                disabled={disableComp}
                icon="upload"
                style={{ marginLeft: '10px' }}
                type="danger"
              >
                Import Attachment
              </Button>
            </Upload>
          </div>
          <div style={{ gridColumnEnd: 'span 5' }}>
            <Table
              columns={[
                {
                  ellipsis: true,
                  title: 'File Name',
                  dataIndex: 'filename',
                  key: 'filename',
                  sorter: (a, b) =>
                    a.filename
                      .toLowerCase()
                      .localeCompare(b.filename.toLowerCase()),
                },
                {
                  title: 'View',
                  dataIndex: 'uuid',
                  key: 'uuidview',
                  width: 80,
                  render: (uuid, rprop) => (
                    <Button
                      icon="download"
                      onClick={_ =>
                        downloadAttachemnetFile(targetInfo)(
                          rprop.filename,
                          uuid
                        )
                      }
                    />
                  ),
                },
                {
                  title: 'Delete',
                  dataIndex: 'uuid',
                  key: 'uuid',
                  width: 80,
                  render: (uuid, rprop) => (
                    <Popconfirm
                      title={`Are you sure to delete this file (${rprop.filename})?`}
                      onConfirm={_ => deleteAttachment(uuid)}
                      onCancel={_ => _}
                      okText="Yes"
                      cancelText="No"
                      disabled={disableComp}
                    >
                      <Button
                        disabled={disableComp}
                        icon="delete"
                        // onClick={_ => deleteAttachment(uuid)}
                      />
                    </Popconfirm>
                  ),
                },
                {
                  title: 'Modifier',
                  dataIndex: 'modifier',
                  key: 'modifier',
                  width: 100,
                  ellipsis: true,
                  render: (text, rptop) => {
                    return rptop.modificationInfo.user
                  },
                },
                {
                  ellipsis: true,
                  title: 'Modified Date',
                  dataIndex: 'modifieddate',
                  key: 'modifieddate',
                  width: 150,
                  render: (text, rptop) => {
                    return moment(rptop.modificationInfo.modDate).format(
                      'MM/DD/YYYY HH:mm:ss'
                    )
                  },
                  sorter: (a, b) =>
                    moment(a.modificationInfo.modDate).valueOf() -
                    moment(b.modificationInfo.modDate).valueOf(),
                  // sortDirections: ['descend'],
                  defaultSortOrder: 'descend',
                },
              ]}
              dataSource={card97fileList}
              size="small"
              // style={{ zIndex: 10000 }}
              scroll={{ y: 200 }}
              pagination={false}
            />
          </div>
          {/* <div
            style={{
              display: 'flex',
              // gridTemplateColumns: 'auto 100px auto 100px',
              overflowY: 'auto',
              overflowX: 'auto',
              gridColumnEnd: 'span 4',
              gap: 5,
              flex: '100px',
              flexWrap: 'wrap',
              maxHeight: '350px',
              height: '350px',
              width: '100%',
              marginTop: '20px',
            }}
          >
            {R.uniqBy(u => u.uuid, card97fileList).map(d => (
              <div
                key={d.uuid}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  // gridTemplateColumns: '30px 250px',
                  columnGap: 10,
                  rowGap: 20,
                  // borderBottom: '1px solid gray',
                  // backgroundColor:'gray'
                  // maxHeight: '50px',
                  // height: '50px',
                  height: 'auto',
                }}
              >
                <Popconfirm
                  title={`Are you sure to delete this file (${d.filename})?`}
                  onConfirm={_ => deleteAttachment(d.uuid)}
                  onCancel={_ => _}
                  okText="Yes"
                  cancelText="No"
                  disabled={disableComp}
                >
                  <Button
                    disabled={disableComp}
                    icon="delete"
                    onClick={_ => deleteAttachment(d.uuid)}
                  />
                </Popconfirm>

                <div
                  style={{
                    display: 'grid',
                    justifyContent: 'left',
                    alignContent: 'center',
                  }}
                >
                  {d.filename}
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </Tabs.TabPane>
    </Tabs>
  )
}

export default DominionExtension
